import { useContext } from 'react';
import { isSupportedCurrency } from '@doist/currency-notations';
import { Box, GroupButton, SelectField, Text } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import Arrow from './arrow.svg';
import css from './controls.module.css';
import { HandwrittenBox } from '@/app/components/handwritten-box/handwritten-box';
import { PricingContext } from '@/app/services/providers/contexts/pricing-context';
export type BillingCycles = 'yearly' | 'monthly';
type PlanControlsProps = {
  children: React.ReactNode;
  className?: string;
};
export function PlanControls({
  children,
  className
}: PlanControlsProps) {
  return <div className={cn(css.controlsContainer, className)} data-sentry-component="PlanControls" data-sentry-source-file="controls.tsx">{children}</div>;
}
PlanControls.BillingCycle = function BillingCycle() {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const {
    billingCycle,
    update
  } = useContext(PricingContext);
  const buttons = [{
    name: t('controls.billedYearly'),
    active: billingCycle === 'yearly',
    value: 'yearly'
  }, {
    name: t('controls.billedMonthly'),
    active: billingCycle === 'monthly',
    value: 'monthly'
  }];
  return <Box className={css.billingCycle}>
            <HandwrittenBox tilt={5} className={css.yearlyNote} arrow={<Arrow width={42} height={33} />} arrowPosition="left">
                {t('controls.save20p')}
            </HandwrittenBox>
            <Text tag="span" size="minor-base" weight="semibold" className={css.cycle}>
                {t('billing.cycle')}
            </Text>
            <GroupButton buttons={buttons} onClick={value => update({
      billingCycle: value as BillingCycles
    })} />
        </Box>;
};
PlanControls.Currency = function Currency() {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const {
    model,
    currency,
    update
  } = useContext(PricingContext);
  return <div className={css.currency}>
            <SelectField id="currency" size="sm" label={t('controls.pricesIn')} value={currency} onChange={e => {
      if (isSupportedCurrency(e.currentTarget.value)) {
        update({
          currency: e.currentTarget.value
        });
      }
    }}>
                {Object.keys(model).map(key => <option value={key} key={key}>
                        {key.toUpperCase()}
                    </option>)}
            </SelectField>
        </div>;
};